module.exports = __webpack_public_path__ + "static/media/submit_simulation.60f0ad68.svg";